import { PluginConfig as ConcurrentStreamCheckPluginConfig } from '@foundation-player/plugin-concurrent-stream-check';
import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Concurrent Stream Check Plugin.
 *
 * @remarks
 * The plugin is enabled via the remote configuration for applicable clients.
 */
export const addConcurrentStreamCheckPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const concurrentStreamCheck = 'foundation.plugin.concurrentStreamCheck';
  const { remoteConfig } = partialBuilderConfig;

  const enabled =
    typeof pluginConfigs[concurrentStreamCheck]?.enabled === 'boolean'
      ? pluginConfigs[concurrentStreamCheck].enabled
      : remoteConfig.concurrentStreamCheck?.enable;

  if (!enabled) {
    return pluginConfigs;
  }

  const config: ConcurrentStreamCheckPluginConfig = {
    interval: pluginConfigs[concurrentStreamCheck]?.interval || remoteConfig.concurrentStreamCheck?.beatInterval || 60,
    endpoints: {
      start:
        pluginConfigs[concurrentStreamCheck]?.endpoints?.start || remoteConfig.concurrentStreamCheck?.startUrl || '',
      stop: pluginConfigs[concurrentStreamCheck]?.endpoints?.stop || remoteConfig.concurrentStreamCheck?.stopUrl || '',
      beat:
        pluginConfigs[concurrentStreamCheck]?.endpoints?.beat || remoteConfig.concurrentStreamCheck?.heartbeatUrl || '',
    },
  };

  if (!config.endpoints.start || !config.endpoints.stop || !config.endpoints.beat) {
    return {
      ...pluginConfigs,
      [concurrentStreamCheck]: undefined,
    };
  }

  return {
    ...pluginConfigs,
    [concurrentStreamCheck]: {
      ...config,
      enabled: true,
    },
  };
};
